import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { motion } from 'framer-motion';
import { OrganizationLookupStepProps } from './types';
import { Search } from 'lucide-react';

const OrganizationLookupStep = (props: OrganizationLookupStepProps) => {
  const {
    innInput,
    innInputError,
    isInnTouched,
    isPending,
    onBlurInnInput,
    onChangeInnInput,
    onSubmit,
    registeredInnError
  } = props;

  return (
    <motion.form
      className="space-y-4"
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -16 }}
      initial={{ opacity: 0, x: -16 }}
      key="lookup"
      noValidate
      onSubmit={onSubmit}
      transition={{ duration: 0.22, ease: 'easeOut' }}
    >
      <div className="space-y-2">
        <Label htmlFor="inn-lookup">ИНН организации</Label>
        <Input
          autoComplete="off"
          disabled={isPending}
          error={Boolean(registeredInnError) || (isInnTouched && Boolean(innInputError))}
          id="inn-lookup"
          inputMode="numeric"
          leftIcon={<Search className="size-5" />}
          onBlur={onBlurInnInput}
          onChange={(event) => onChangeInnInput(event.target.value.replace(/\D/g, '').slice(0, 12))}
          placeholder="7707083893"
          required
          value={innInput}
        />
        {registeredInnError ? (
          <p className="px-3 text-xs text-[hsl(var(--error-text))]">{registeredInnError}</p>
        ) : isInnTouched && innInputError ? (
          <p className="px-3 text-xs text-[hsl(var(--error-text))]">{innInputError}</p>
        ) : (
          <p className="px-3 text-xs text-muted-foreground">10 цифр для юр.лица, 12 для ИП</p>
        )}
      </div>

      <motion.div whileTap={{ scale: 0.99 }}>
        <Button
          className="w-full"
          leftIcon={isPending ? undefined : <Search className="size-5" />}
          loading={isPending}
          size="md"
          type="submit"
        >
          {isPending ? 'Ищем данные...' : 'Найти организацию'}
        </Button>
      </motion.div>
    </motion.form>
  );
};

export default OrganizationLookupStep;